import { NavLink, useLocation } from 'react-router-dom'
import { msg, t } from '@lingui/core/macro'

import { cn } from '@jotta/utils/css'

const bizNavLinksConfig = [
  {
    to: '/biz',
    label: msg`Dashboard`,
  },
  {
    to: '/biz/users',
    label: msg`Users`,
  },
  {
    to: '/biz/settings',
    label: msg`Settings`,
  },
]

export function BizHeader() {
  const { pathname } = useLocation()

  return (
    <>
      {bizNavLinksConfig.map(link => (
        <NavLink
          key={link.to}
          to={link.to}
          className={cn('p-4 text-navigation hover:text-primary', {
            'text-primary': pathname === link.to,
          })}
        >
          {t(link.label)}
        </NavLink>
      ))}
    </>
  )
}
